import PropTypes from 'prop-types';
import React from 'react';

const Variable = ({ value }) => {
	return <span>{value}</span>;
};

Variable.propTypes = {
	value: PropTypes.string.isRequired
};

export default Variable;
